export default __webpack_public_path__ + "static/media/lb-icon2-red.744b4b44.svg";